import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Calendar
} from 'react-big-calendar'
import {
  Button,
  Input,
  Dropdown
} from 'semantic-ui-react'

const CardChairUX = (props: any) => {
    return(
      <div
        id="CardChairUX-div-0"
        style={{display: "flex", height: "100%"}}>
        <div
          id="CardChairUX-div-37"
          style={{flex: "1 1 6.5%"}}>

          <div
            id="CardChairUX-div-41"
            style={{display: props.mode === "chair" ? "block" : "none", padding: "5px"}}>

            <div
              id="CardChairUX-div-9"
              style={{fontWeight: "bold",margin: "0px 0px 10px 0px"}}>
              {props.languageUX === "en" ? "List of chairs" : "รายการเก้าอี้"}
            </div>
            <div
              id="CardChairUX-div-54"
              style={{display: "flex", justifyContent:"space-between",margin: "10px 0px"}}>

              <div
                id="CardChairUX-div-55"
                style={{width: "33%"}}>
                {props.languageUX === "en" ? "Chair number" : "เลขเก้าอี้"}
                <Input
                  icon="filter"
                  id="CardChairUX-Input-58"
                  onChange={props.onChangeFilterChairNo}
                  style={{width: "100%", display: "none"}}
                  value={props.filterChairNo}>
                </Input>
                <Dropdown
                  clearable={true}
                  id="CardChairUX-Dropdown-63"
                  onChange={props.onChangeFilterChairNo}
                  options={props.chairNoOptions}
                  search={true}
                  selection={true}
                  value={props.filterChairNo}>
                </Dropdown>
              </div>
              <div
                id="CardChairUX-div-57"
                style={{width: "33%"}}>
                {props.languageUX === "en" ? "status" : "สถานะ"}
                <Input
                  icon="filter"
                  id="CardChairUX-Input-60"
                  onChange={props.onChangeFilterStatus}
                  style={{width: "100%", display: "none"}}
                  value={props.filterStatus}>
                </Input>
                <Dropdown
                  clearable={true}
                  id="CardChairUX-Dropdown-64"
                  onChange={props.onChangeFilterStatus}
                  options={props.statusOptions}
                  search={true}
                  selection={true}
                  value={props.filterStatus}>
                </Dropdown>
              </div>
              <div
                id="CardChairUX-div-61"
                style={{width: "33%"}}>
                {props.languageUX === "en" ? "clinic" : "คลินิก"}
                <Input
                  icon="filter"
                  id="CardChairUX-Input-62"
                  onChange={props.onChangeFilterClinic}
                  style={{width: "100%", display: "none"}}
                  value={props.filterClinic}>
                </Input>
                <Dropdown
                  clearable={true}
                  id="CardChairUX-Dropdown-65"
                  onChange={props.onChangeFilterClinic}
                  options={props.clinicOptions}
                  search={true}
                  selection={true}
                  value={props.filterClinic}>
                </Dropdown>
              </div>
            </div>
            <div
              id="CardChairUX-div-2"
              style={{position: "relative"}}>

              <Table
                NoDataComponent={props.loader?()=>null:undefined}
                data={props.chairList}
                getTrProps={props.rowProps}
                headers=",เลขเก้าอี้,สถานะ,คลีนิค"
                id="CardChairUX-Table-4"
                keys="select,name,status_name,division_name"
                showPagination={false}
                style={{height: "calc(100dvh - 15.5rem)"}}
                widths="30,100,100">
              </Table>
              <div
                id="CardChairUX-div-70">
                {props.loader}
              </div>
            </div>
            <div
              id="CardChairUX-div-50">

              <Button
                color="green"
                id="CardChairUX-Button-51"
                onClick={props.selectChairFinish}
                size="tiny">
                {props.languageUX === "en" ? "finish" : "เสร็จสิ้น"}
              </Button>
              <Button
                color="red"
                id="CardChairUX-Button-52"
                onClick={props.clearChair}
                size="tiny">
                {props.languageUX === "en" ? "clear" : "เคลียร์"}
              </Button>
            </div>
          </div>
          <div
            id="CardChairUX-div-1"
            style={{ position: "relative", display: props.mode === "home" ? "block" : "none", padding: "5px"}}>

            <div
              id="CardChairUX-div-43"
              style={{marginBottom: "10px"}}>

              <div
                id="CardChairUX-div-66"
                style={{display: "flex", alignItems: "center", marginBottom: "0.5rem"}}>

                <label
                  id="CardChairUX-label-68"
                  style={{marginRight: "0.75rem"}}>
                  {props.languageUX === "en" ? "department" : "แผนก"}
                </label>
                <Dropdown
                  className="size small"
                  fluid={true}
                  id="CardChairUX-Dropdown-69"
                  onChange={props.onChangeDivision}
                  options={props.divisionOptions}
                  placeholder="Please select the division"
                  search={true}
                  selectOnBlur={true}
                  selection={true}
                  value={props.selectedDivisionId}>
                </Dropdown>
              </div>
              <div
                id="CardChairUX-div-47"
                style={{display: "flex",}}>

                <div
                  id="CardChairUX-div-49"
                  style={{display: "flex", fontWeight: "bold"}}>
                  เก้าอี้:
                </div>
                <div
                  id="CardChairUX-div-48"
                  style={{marginLeft: "10px"}}>
                  {props.selectedChairs}
                </div>
              </div>
              <div
                id="CardChairUX-div-46">

                <Button
                  color="green"
                  disabled={!props.selectedDivisionId}
                  id="CardChairUX-Button-44"
                  onClick={props.selectChair}
                  size="tiny">
                  {props.languageUX === "en" ? "Choose a chair" : "เลือกเก้าอี้"}
                </Button>
                <Button
                  color="red"
                  disabled={!props.selectedDivisionId}
                  id="CardChairUX-Button-45"
                  onClick={props.clearChair}
                  size="tiny">
                  {props.languageUX === "en" ? "clear" : "เคลียร์"}
                </Button>
              </div>
            </div>
            <div
              id="CardChairUX-div-42">
              {props.zoneSelector}
            </div>
            <div
              id="CardChairUX-div-40"
              style={{ marginTop: "10px"}}>
              {props.cardSelectTemplate}
            </div>
          </div>
        </div>
        <div
          id="CardChairUX-div-38"
          style={{flex: 3, padding: "5px", height: "90vh", position: "relative"}}>

          <div
            id="CardChairUX-div-8"
            style={{fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Service hours" : "วันเวลาที่ให้บริการ"}
          </div>
          <Calendar
            eventPropGetter={props.eventPropGetter}
            events={props.blockList || []}
            id="CardChairUX-Calendar-39"
            localizer={props.localizer}
            max={props.maxTime}
            min={props.minTime}
            onNavigate={props.onNavigate}
            onRangeChange={props.onRangeChange}
            onSelectEvent={props.onSelectEvent}>
          </Calendar>
          <div>
            {props.calendarLoader}
          </div>
        </div>
      </div>
    )
}


export default CardChairUX

export const screenPropsDefault = {"cardSelectTemplate":"[CardSelectTemplate]","divisionChoices":{"0":{"key":1,"text":"a","value":1}},"dsbList":{"0":1,"1":2},"mode":"home","selectedChairs":"00023-1, 00024-2","zoneSelector":"[ZoneSelector]"}

/* Date Time : Wed Sep 03 2025 09:27:03 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardChairUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ position: \"relative\", display: props.mode === \"home\" ? \"block\" : \"none\", padding: \"5px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 2,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "props.loader?()=>null:undefined"
        },
        "data": {
          "type": "code",
          "value": "props.chairList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "value",
          "value": ",เลขเก้าอี้,สถานะ,คลีนิค"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Table-4"
        },
        "keys": {
          "type": "value",
          "value": "select,name,status_name,division_name"
        },
        "minRows": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100dvh - 15.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "30,100,100"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเวลาที่ให้บริการ",
          "valueEN": "Service hours"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการเก้าอี้",
          "valueEN": "List of chairs"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",margin: \"0px 0px 10px 0px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{flex: \"1 1 6.5%\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, padding: \"5px\", height: \"90vh\", position: \"relative\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "react-big-calendar",
      "id": 39,
      "name": "Calendar",
      "parent": 38,
      "props": {
        "eventPropGetter": {
          "type": "code",
          "value": "props.eventPropGetter"
        },
        "events": {
          "type": "code",
          "value": "props.blockList || []"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Calendar-39"
        },
        "localizer": {
          "type": "code",
          "value": "props.localizer"
        },
        "max": {
          "type": "code",
          "value": "props.maxTime"
        },
        "min": {
          "type": "code",
          "value": "props.minTime"
        },
        "onNavigate": {
          "type": "code",
          "value": "props.onNavigate"
        },
        "onRangeChange": {
          "type": "code",
          "value": "props.onRangeChange"
        },
        "onSelectEvent": {
          "type": "code",
          "value": "props.onSelectEvent"
        }
      },
      "seq": 39,
      "void": true
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardSelectTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"10px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{display: props.mode === \"chair\" ? \"block\" : \"none\", padding: \"5px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.zoneSelector"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-42"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"10px\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Button",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกเก้าอี้",
          "valueEN": "Choose a chair"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Button-44"
        },
        "onClick": {
          "type": "code",
          "value": "props.selectChair"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Button",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Button-45"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearChair"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-46"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedChairs"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "เก้าอี้: "
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", fontWeight: \"bold\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-50"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Button",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": "เสร็จสิ้น",
          "valueEN": "finish"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Button-51"
        },
        "onClick": {
          "type": "code",
          "value": "props.selectChairFinish"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Button",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Button-52"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearChair"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent:\"space-between\",margin: \"10px 0px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขเก้าอี้",
          "valueEN": "Chair number"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{width: \"33%\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{width: \"33%\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Input",
      "parent": 55,
      "props": {
        "icon": {
          "type": "value",
          "value": "filter"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Input-58"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterChairNo"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterChairNo"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Input",
      "parent": 57,
      "props": {
        "icon": {
          "type": "value",
          "value": "filter"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Input-60"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterStatus"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterStatus"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "คลินิก",
          "valueEN": "clinic"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{width: \"33%\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Input",
      "parent": 61,
      "props": {
        "icon": {
          "type": "value",
          "value": "filter"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Input-62"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterClinic"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterClinic"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Dropdown",
      "parent": 55,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Dropdown-63"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterChairNo"
        },
        "options": {
          "type": "code",
          "value": "props.chairNoOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterChairNo"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Dropdown",
      "parent": 57,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Dropdown-64"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterStatus"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterStatus"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Dropdown",
      "parent": 61,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Dropdown-65"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilterClinic"
        },
        "options": {
          "type": "code",
          "value": "props.clinicOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterClinic"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-label-68"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.75rem\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Dropdown",
      "parent": 66,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-Dropdown-69"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Please select the division"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selectOnBlur": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivisionId"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.loader"
        },
        "id": {
          "type": "value",
          "value": "CardChairUX-div-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calendarLoader"
        }
      },
      "seq": 71,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardChairUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "cardSelectTemplate": "[CardSelectTemplate]",
    "divisionChoices": {
      "0": {
        "key": 1,
        "text": "a",
        "value": 1
      }
    },
    "dsbList": {
      "0": 1,
      "1": 2
    },
    "mode": "home",
    "selectedChairs": "00023-1, 00024-2",
    "zoneSelector": "[ZoneSelector]"
  },
  "width": 85
}

*********************************************************************************** */
